import * as actionTypes from './actionTypes';
import { push, goBack } from 'react-router-redux';
import { queryParamsString, isNavigating, currentPath } from './selectors';
import { RESET_APP_STATE } from 'store/actionTypes';

// Selectors
import { getAppName } from 'store/reducers/userInteractions/selectors';

// Constants
import { HOME_ROUTE } from 'constants/routes';
import { APP_NAMES } from 'constants/appName';
import { resetScrollPosition } from 'utils/DOM';

export const goPreviousPath = () => async (dispatch, getState) => {
  if (isNavigating(getState())) {
    return null;
  } else {
    await dispatch(setIsNavigating(true));
    dispatch(goBack());
    dispatch(setIsNavigating(false));
  }
};

export const goTo = (path, direction) => async (dispatch, getState) => {
  const state = getState();
  const toRoute = `${path}${queryParamsString(state)}`;
  const previousPath = currentPath(getState());
  const isSelfCheckIn = getAppName(getState()) === APP_NAMES.SELF_CHECK_IN;
  if (isNavigating(state)) {
    return null;
  } else {
    await dispatch(setIsNavigating(true));
    dispatch(setDirectionPath(direction));
    dispatch(push(toRoute));
    resetScrollPosition(0);
    dispatch(setPreviousPath(previousPath));
    dispatch(setCurrentPath(path));
    dispatch(setIsNavigating(false));
    if (path === HOME_ROUTE && !isSelfCheckIn) {
      dispatch({
        type: RESET_APP_STATE
      });
    }
  }
};

export const setNavigation = navigation => {
  return {
    type: actionTypes.SET_NAVIGATION,
    payload: navigation
  };
};

const setIsNavigating = isNavigating => {
  return {
    type: actionTypes.SET_IS_NAVIGATING,
    payload: isNavigating
  };
};

export const setCurrentPath = path => {
  return {
    type: actionTypes.SET_CURRENT_PATH,
    payload: path
  };
};

const setPreviousPath = path => {
  return {
    type: actionTypes.SET_PREVIOUS_PATH,
    payload: path
  };
};

const setDirectionPath = direction => {
  return {
    type: actionTypes.SET_DIRECTION,
    payload: direction
  };
};



// WEBPACK FOOTER //
// ./src/store/reducers/navigation/actions.js